var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"pt-3",attrs:{"title":"کپی"}},[_c('b-icon',{staticClass:"cursor-pointer h4 m-3",attrs:{"icon":"files"},on:{"click":function($event){return _vm.duplicateItem()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }